import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(advancedFormat);
dayjs.extend(timezone);

export const inferTimezone = (): string => dayjs.tz.guess();

export const nowUtc = (): string => dayjs.utc().format('MMM Do, HH:mm:ss');

export const nowTZ = (tz: string): string =>
  dayjs().tz(tz).format('MMM Do, HH:mm:ss');

export const nowPacificKiritimati = (): string => nowTZ('Pacific/Kiritimati');

export const nowPacificMidway = (): string => nowTZ('Pacific/Midway');

/**
 * Computes and returns unix epoch in seconds
 * @returns Current unix timestamp in seconds
 */
export const unixNowSec = (): number => Math.floor(new Date().getTime() / 1000);

export const ONE_DAY_SEC = 3600 * 24;
export const ONE_MONTH_SEC = ONE_DAY_SEC * 30;

export type PMNDate = dayjs.Dayjs;

export const addDays = (date: Date | string, dayCount: number): Date =>
  dayjs(date)
    .add(dayCount - 1, 'days')
    .toDate();

export const formatPMNDate = (date: PMNDate, format?: string): string =>
  date.format(format);

export const formatNativeDate = (date: Date, format?: string): string =>
  dayjs(date).format(format);

export const formatStringDate = (date: string, format?: string): string =>
  dayjs(date).format(format);

export const toDate = (date: string, format = 'YYYY-MM-DD'): Date =>
  dayjs(date, format).toDate();

export const calendarDayDiff = (date1: Date | string, date2: Date | string): number =>
  (dayjs(date1).startOf('day')).diff(dayjs(date2).startOf('day'), 'day');